if (!customElements.get("custom-product-block-inner")) {
  customElements.define(
    "custom-product-block-inner",
    class CustomProductBlockInner extends HTMLElement {
      constructor() {
        super();
        this.discount_data = this.querySelector('[id^="ProductJSON-"]');
        this.sales_badge = this.querySelector(".product-label--sale");
        this.sales_badge_content = this.sales_badge.querySelector("span");
        this.product_price = this.querySelector(".product-block__price");
        this.product_price_amount = this.product_price.querySelector(
          ".product-price__amount span"
        );
        this.product_price_compare = this.product_price.querySelector(
          ".product-price__compare span"
        );

        if (this.discount_data?.textContent) {
          try {
            this.discount_data = JSON.parse(this.discount_data.textContent);

            // Select swatches
            this.swatches = this.querySelectorAll(
              ".product-block-options__item"
            );

            // If no swatches exist, reset discount_data and exit early
            if (!this.swatches.length) {
              this.discount_data = null;
              return;
            }

            // Initialize with the first swatch
            this.updateBadge(this.swatches[0]);

            // Add event listeners to swatches
            this.swatches.forEach((swatch) => {
              swatch.addEventListener(
                "mouseenter",
                this.updateBadge.bind(this, swatch)
              );
              swatch.addEventListener(
                "click",
                this.updateBadge.bind(this, swatch)
              );
            });

            console.log("Event listeners added");
          } catch (error) {
            console.error("Error parsing discount_data:", error);
            this.discount_data = null; // Prevent further errors
          }
        } else {
          this.discount_data = null; // Ensure it's always defined
        }
      }

      updateBadge(swatch) {
        const selected_swatch = this.discount_data[swatch.dataset.optionItem];
        const isDiscounted = selected_swatch.is_discounted;

        this.sales_badge.classList.toggle("hidden", !isDiscounted);
        this.sales_badge_content.textContent = isDiscounted
          ? selected_swatch.discounted_price_label
          : "";

        this.product_price_amount.textContent = isDiscounted
          ? selected_swatch.discounted_price
          : selected_swatch.product_compare_at_price;
        this.product_price_compare.textContent = isDiscounted
          ? selected_swatch.product_compare_at_price
          : "";
      }
    }
  );
}
